<template>
    <el-container>
        <el-header style="height: auto">
            <el-form :inline="true" :model="fromAlarmInfo" ref="fromAlarmInfo" class="demo-form-inline" :rules="rules">
                <el-row :gutter="20">
                    <el-col>
                        <td-permission :permissions="permissionsQuery">
                            <div slot="havePermission">
                                <el-form-item :label="$t('common.ALARM_TYPE')" prop="sAlarmEventId">
                                    <td-select
                                        v-model="fromAlarmInfo.sAlarmEventId"
                                        :isPage="true"
                                        keys="sId"
                                        text="sName"
                                        :placeholder="$t('common.PLEASE_SELECT')"
                                        :url="alarmEventUrl"
                                        requestType="post"
                                    ></td-select>
                                </el-form-item>
                                <el-form-item :label="$t('common.ALARM_LEVEL')" prop="sAlarmLevelId">
                                    <td-select v-model="fromAlarmInfo.sAlarmLevelId" keys="sId" text="sName" :options="alarmLevelList" :placeholder="$t('common.PLEASE_SELECT')"></td-select>
                                </el-form-item>
                                <el-form-item :label="$t('pgCommon.ALARM_GROUP')" v-show="alarmTypeShow" prop="sAlarmTypeId">
                                    <td-tree-select
                                        ref="TdAlarmTypeTree"
                                        :treeList="alarmTypeList"
                                        :lazyloading="lazyloading"
                                        :defaultProps="defaultProps"
                                        :inputShow="inputShow"
                                        :nodeKey="nodeKey"
                                        :expandAll="expandAll"
                                        :multiple="true"
                                    ></td-tree-select>
                                </el-form-item>
                                <el-form-item :label="$t('common.DEVICE')" prop="sDeviceId">
                                    <td-tree-select
                                        ref="TdDeviceTree"
                                        :treeList="deviceList"
                                        :lazyloading="deviceLazyload"
                                        :defaultProps="deviceProps"
                                        :inputShow="true"
                                        :nodeKey="nodeKey"
                                        :imgloading="true"
                                        :isDistributed="false"
                                        @queryData="queryDeviceTreeData"
                                        @querySearchData="queryDeviceSearchData"
                                        :calInternal="false"
                                        v-model="sDevIds"
                                        :isPaging="true"
                                        :params="params"
                                        :customProp="customProp"
                                        :multiple="true"
                                        :checkStrictly="false"
                                    ></td-tree-select>
                                </el-form-item>
                            </div>
                        </td-permission>
                        <td-permission :permissions="permissionsQuery">
                            <div slot="havePermission">
                                <el-form-item :label="$t('common.ALARM_DATE')" prop="startTime">
                                    <td-date-time
                                        :editable="false"
                                        v-model="fromAlarmInfo.startTime"
                                        type="datetime"
                                        :pickerOptions="pickerBeginDateBefore"
                                        :placeholder="$t('common.START_TIME')"
                                        :clearable="false"
                                    ></td-date-time>
                                </el-form-item>
                                <el-form-item :label="$t('common.UNTIL')" prop="endTime">
                                    <td-date-time
                                        :editable="false"
                                        v-model="fromAlarmInfo.endTime"
                                        type="datetime"
                                        :pickerOptions="pickerBeginDateAfter"
                                        :placeholder="$t('common.END_TIME')"
                                        :clearable="false"
                                    ></td-date-time>
                                </el-form-item>
                            </div>
                        </td-permission>
                        <el-form-item class="paddingLeft10">
                            <td-button type="primary" :permissions="permissionsQuery" :loading="loading" @click="btnClickQuery">{{ $t('common.QUERY') }}</td-button>
                            <td-button type="button" :permissions="permissionsExport" :loading="exportLoading" @click="btnExport">{{ $t('common.EXPORT') }}</td-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-tag type="success" solt="dataTips" style="float:right" v-show="showMaxLimit">
                {{ $t('common.DATA_COUNT') }}{{ totalCount }}{{ $t('common.NUMBER_COUNT') }},{{ $t('common.CURRENT_COUNT') }}{{ currentCount }}{{ $t('common.NUMBER_COUNT') }}
            </el-tag>
            <viewer :images="picList" style="width:0px;height:0px">
                <img v-for="(url, name) in picList" :src="url" :key="name" id="imageShow" />
            </viewer>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                ref="tableInfo"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
                :permissions="permissionsQuery"
                :rowKey="rowKey"
                :hasMutiSelect="false"
                :hasLoading="hasLoading"
            ></td-table>
        </el-main>
        <!-- <el-image style="width:0px;height:0px" id="imageShow" :src="defaultImg" :preview-src-list="picList"> </el-image> -->
        <dialogExportPicture
            v-if="exportPictureVailable"
            :title="title"
            :orgId="orgId"
            :exportParam="exportParam"
            :exportPictureVailable="exportPictureVailable"
            @submit="submit"
            @dlalogExportPictureClose="dlalogExportPictureClose"
        ></dialogExportPicture>
    </el-container>
</template>

<script>
import dialogExportPicture from './components/dialogExportPicture.vue';
import api from './assets/api.js';
export default {
    // 初始化渲染
    components: {
        dialogExportPicture
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.queryMaxLimitCount();
        this.queryMaxExportCount();
        this.initSelect();
    },
    //默认图标
    computed: {
        defaultImg: function() {
            return 'skin/skinOne/img/skinOne.png';
        }
    },
    // 定义数据
    data() {
        return {
            picList: ['skin/skinOne/img/skinOne.png'],
            fromAlarmInfo: {
                sName: '',
                sSerialNumber: '',
                startTime: new Date(Date.parse((this.getNowDate() + ' 00:00:00').replace(/-/g, '/'))),
                endTime: new Date(Date.parse((this.getNowDate() + ' 23:59:59').replace(/-/g, '/')))
            },
            // 对表单进行数据验证
            alarmTypeShow: false,
            hasLoading: false,
            rules: {},
            permissionsQuery: ['alarmQuery:view'],
            permissionsExport: ['alarmQuery:export'],
            triggerDeviceType: [],
            alarmLevelList: [],
            alarmTypeList: [],
            alarmEventList: [],
            deviceTreeFilter: [],
            sDevIds: [],
            editItem: '',
            dialogEventVisible: false,
            dialogClassifyVisible: false,
            exportPictureVailable: false,
            tableData: [],
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            exportLoading: false,
            lazyloading: false,
            isSingleCheck: true,
            inputShow: false,
            nodeKey: 'id',
            expandAll: true,
            showMaxLimit: false,
            maxLimitCount: null,
            maxLimitExportCount: null,
            rowKey: 'sId',
            queryFlag: false,
            alarmEventUrl: '/alarmserver/alarm/getAlarmEventDevice',
            defaultProps: {
                children: 'children',
                label: 'typeName',
                id: 'id',
                parentId: 'parentId'
            },
            interfaceName: { query: '/device/queryDeviceOrgTree', search: '/device/queryDeviceOrgTreeByName' },
            params: {
                includeSelf: true, // 查询条件是否包含自己
                parentId: '',
                rootCodes: this.$common.initOrgTreeParam.SCODE,
                orgTypeIds: this.$common.initOrgTreeParam.ORGTYPEIDS
            },
            deviceProps: {
                children: 'children',
                label: 'caption',
                id: 'id',
                imgName: 'sIcon',
                parentId: 'parentId'
            },
            customProp: ['noPermission'],
            deviceList: [],
            deviceLazyload: true,
            columns: [
                {
                    prop: 'sDeviceName',
                    label: this.$t('common.DEVICE_NAME')
                },
                {
                    prop: 'sAlarmEventName',
                    label: this.$t('common.ALARM_TYPE')
                },
                {
                    prop: 'dtTime',
                    label: this.$t('common.ALARM_DATE'),
                    align: 'center'
                },
                {
                    prop: 'sAlarmLevelName',
                    label: this.$t('common.ALARM_LEVEL'),
                    tableWidth: '140'
                },
                {
                    prop: 'sDescribe',
                    label: this.$t('common.DESCRIPTION'),
                    tableWidth: '280',
                    showOverflowTooltip: true
                },
                {
                    prop: '',
                    label: this.$t('common.OPERATE'),
                    tableWidth: '200',
                    align: 'center',
                    render: (createElement, params) => {
                        let contextArr = [];
                        if (params.row.sVideoFile) {
                            contextArr.push(
                                createElement(
                                    'td-button',
                                    {
                                        props: { type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.showVideo(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.LINKAGE_VIDEO')
                                )
                            );
                        }
                        if (params.row.sDeviceType == '5' && params.row.showFrontButtonFlag) {
                            contextArr.push(
                                createElement(
                                    'td-button',
                                    {
                                        props: { type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.showVideoFront(params.row);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.ALARM_VIDEO_FRONT')
                                )
                            );
                        }
                        if (params.row.pic) {
                            contextArr.push(
                                createElement(
                                    'td-button',
                                    {
                                        props: { type: 'text', size: 'small' },
                                        on: {
                                            click: () => {
                                                this.imageShow(params.row.pic);
                                            }
                                        }
                                    },
                                    this.$t('pgCommon.ALARM_PIC')
                                )
                            );
                        }
                        return createElement('div', contextArr.length == 0 ? {} : contextArr);
                    }
                }
            ],
            pickerBeginDateBefore: {
                disabledDate: time => {
                    let dateVal = this.fromAlarmInfo.endTime;
                    if (dateVal) {
                        return time.getTime() > new Date(Date.parse(String(dateVal).replace(/-/g, '/'))).getTime();
                    }
                }
            },
            pickerBeginDateAfter: {
                disabledDate: time => {
                    let dateVal = this.fromAlarmInfo.startTime;
                    if (dateVal) {
                        return time.getTime() <= new Date(Date.parse(String(dateVal).replace(/-/g, '/'))).getTime() - 8.64e7;
                    }
                }
            }
        };
    },
    // 方法的实现
    methods: {
        initSelect() {
            api.getAlarmLevel('{}', response => {
                this.alarmLevelList = response.data.content;
            });
            // api.getAlarmTypeTree('', response => {
            //     this.alarmTypeList = response.data.content;
            //     if (this.alarmTypeList && this.alarmTypeList.length > 0) {
            //         this.alarmTypeShow = true;
            //         this.columns.splice(4, 0, {
            //             prop: 'sAlarmTypeName',
            //             label: this.$t('pgCommon.ALARM_GROUP'),
            //             tableWidth: '140'
            //         });
            //     }
            // });
            let deviceItem = {
                value: false,
                field: 'device'
            };
            this.deviceTreeFilter.push(deviceItem);
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.btnClickQuery();
        },
        getPermissionsStatus(permissions) {
            this.queryFlag = permissions;
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.submit();
        },
        //查询点击按钮
        btnClickQuery() {
            if (!this.isSelectDevice()) {
                this.$message({ type: 'info', showClose: true, message: this.$t('pgMessage.PLEASE_SELECT_QUERY_DEVICE_CONDITION') });
                return;
            }
            this.currentPage = 1;
            this.btnQuery();
        },
        //是否选择设备条件
        isSelectDevice() {
            let deviceTreeNodeList = this.$refs.TdDeviceTree.getSelectedNodes();
            if (deviceTreeNodeList && deviceTreeNodeList.length > 0) {
                return true;
            }
            return false;
        },
        //点击报警图片
        imageShow(pic) {
            this.picList = pic;
            $('#imageShow').click();
        },
        // 查询数据
        btnQuery() {
            this.$refs['fromAlarmInfo'].validate(valid => {
                if (valid) {
                    this.loading = true;
                    let param = this.getParam();
                    api.getAlarmInfo(JSON.stringify(param), response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('alarm/getAlarmInfo', response.data.statusMessage);
                            this.loading = false;
                            return;
                        }
                        this.tableData = [];
                        let dataList = response.data.content;
                        //处理报警图片
                        if (dataList && dataList.length > 0) {
                            dataList.forEach(element => {
                                let tempPic = [];
                                if (element.sSnapPictures) {
                                    let snapData = JSON.parse(element.sSnapPictures);
                                    snapData.forEach(element1 => {
                                        //增加nginx代理
                                        tempPic.push(this.insertStr(element1.url, 5, '//' + window.location.host));
                                    });
                                    element.pic = tempPic;
                                }
                                this.tableData.push(element);
                            });
                        }
                        this.totalCount = response.data.count;
                        if (this.maxLimitCount && response.data.count >= 100 && response.data.count >= this.maxLimitCount) {
                            this.total = this.maxLimitCount;
                            this.showMaxLimit = true;
                        } else {
                            this.total = response.data.count;
                            this.showMaxLimit = false;
                        }
                        this.$refs['tableInfo']._initTableHeight();
                        this.currentCount = this.total;
                        this.loading = false;
                    });
                }
            });
        },
        insertStr(soure, start, newStr) {
            return window.location.protocol + newStr + soure.slice(start);
        },
        // 获取选中表格数据的id
        getTableSelectId() {
            let selectData = this.$refs.tableInfo.getSelectAllRows();
            let tableId = [];
            for (let i = 0; i < selectData.length; i++) {
                tableId.push(selectData[i].sId);
            }
            return tableId;
        },
        // 批量删除
        btnDeleteInfo() {
            let tableId = this.getTableSelectId();
            if (tableId.length === 0) {
                this.$message({ showClose: true, message: this.$t('common.PLEASE_SELECT'), type: 'warning' });
                return;
            }
            this.btnDelete(tableId);
        },
        // 删除接口
        btnDelete(sId) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            }).then(() => {
                api.deleteAlarmInfo(JSON.stringify(sId), response => {
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('alarm/deleteAlarmInfo', response.data.statusMessage);
                        return;
                    }
                    this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                    this.submit();
                });
            });
        },
        queryDeviceTreeData: function(item) {
            //查询报警设备类型
            if (this.triggerDeviceType.length == 0) {
                api.getDeviceTypeList('', response => {
                    let deviceType = response.data.content;
                    if (deviceType) {
                        for (let i = 0; i < deviceType.length; i++) {
                            this.triggerDeviceType.push(deviceType[i].iId);
                        }
                        this.deviceTreeData(item);
                    }
                });
            } else {
                this.deviceTreeData(item);
            }
        },
        //组织设备树
        deviceTreeData: function(item) {
            if (item.parentId === '' || item.parentId === null || item.parentId === undefined) {
                item.parentId = item.parentId = '';
            }
            let queryParam = {
                includeSelf: true, // 查询条件是否包含自己
                parentId: item.parentId,
                rootCodes: this.$common.initOrgTreeParam.SCODE,
                orgTypeIds: this.$common.initOrgTreeParam.ORGTYPEIDS,
                noPermission: item.noPermission,
                deviceTypeList: this.triggerDeviceType,
                currentPage: item.currentPage,
                pageSize: item.pageSize
            };
            api.findDeviceTree(JSON.stringify(queryParam), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/device/queryDeviceOrgTree', response.data.statusMessage);
                    return;
                }
                // 初始化树形数据
                this.$refs.TdDeviceTree.initData(response.data.content);
            });
        },
        queryDeviceSearchData: function(item) {
            //查询报警设备类型
            if (this.triggerDeviceType.length == 0) {
                api.getDeviceTypeList('', response => {
                    let deviceType = response.data.content;
                    if (deviceType) {
                        for (let i = 0; i < deviceType.length; i++) {
                            this.triggerDeviceType.push(deviceType[i].iId);
                        }
                        this.deviceSearchData(item);
                    }
                });
            } else {
                this.deviceSearchData(item);
            }
        },
        //组织设备树查询
        deviceSearchData: function(item) {
            let queryParam = {
                currentPage: item.currentPage,
                pageSize: item.pageSize,
                deviceTypeList: this.triggerDeviceType,
                caption: item.caption
            };
            api.queryDeviceOrgTreeByName(JSON.stringify(queryParam), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/device/queryDeviceOrgTreeByName', response.data.statusMessage);
                    return;
                }
                // 初始化树形数据
                this.$refs.TdDeviceTree.initData(response.data.content);
            });
        },
        // 导出
        btnExport() {
            if (!this.isSelectDevice()) {
                this.$message({ type: 'info', showClose: true, message: this.$t('pgMessage.PLEASE_SELECT_EXPORT_DEVICE_CONDITION') });
                return;
            }
            this.$refs['fromAlarmInfo'].validate(valid => {
                if (valid) {
                    let param = this.getParam();
                    this.exportParam = param;
                    this.title = 'pgCommon.EXPORT'; // 标题
                    this.exportPictureVailable = true;
                }
            });
        },
        // 导出
        btnExportContent() {
            this.exportLoading = true;
            let param = this.getParam();
            param.pageSize = 10000;
            api.checkHasPicture(JSON.stringify(param), response => {
                if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('alarm/checkHasPicture', response.data.statusMessage);
                    this.exportLoading = false;
                    return;
                }
                let isContainPic = response.data.content;
                if (isContainPic) {
                    this.exportLoading = false;
                    this.title = 'pgCommon.EXPORT'; // 标题
                    this.exportPictureVailable = true;
                } else {
                    let responseType = 'arraybuffer';
                    api.exportAlarmInfo(param, responseType, response => {
                        this.exportLoading = false;
                        let _response = response;
                        try {
                            _response = JSON.parse(this.decodeUTF8(new Uint8Array(response.data)));
                            if (_response.statusCode) {
                                if (_response.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                    this.$message({ showClose: true, message: _response.statusMessage, type: 'error' });
                                    return;
                                }
                            }
                        } catch (e) {
                            // this.$log.error('/device/exportAlarmInfo', e);
                        }
                        this.$log.info('exportAlarmInfo response ', response);
                        let blob = new Blob([response.data], { type: 'application/x-xls' });
                        this.content = response.data;
                        // 汉字解码
                        let filename = decodeURIComponent(response.headers['filename']);
                        if (window.navigator.msSaveOrOpenBlob) {
                            // 兼容IE10
                            navigator.msSaveBlob(blob, filename);
                        } else {
                            //  chrome/firefox
                            let aTag = document.createElement('a');
                            aTag.download = filename;
                            aTag.href = window.URL.createObjectURL(blob);
                            aTag.click();
                            URL.revokeObjectURL(aTag.href);
                        }
                    });
                }
            });
        },

        // 查询页面最大数据数量
        queryMaxLimitCount() {
            let queryCountParam = { str: 'maxCountLimit' };
            api.getMaxLimitCount(queryCountParam, response => {
                if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('alarm/getMaxLimitCount', response.data.statusMessage);
                    return;
                }
                this.maxLimitCount = response.data.content;
            });
        },
        // 查询允许导出的最大数量
        queryMaxExportCount() {
            let queryExportCountParam = { str: 'maxExportLimit' };
            api.getMaxLimitCount(queryExportCountParam, response => {
                if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('alarm/getMaxLimitCount', response.data.statusMessage);
                    return;
                }
                this.maxLimitExportCount = response.data.content;
            });
        },
        // 获取查询参数
        getParam() {
            let alarmTypeNode = this.$refs.TdAlarmTypeTree.getSelectedNodes();
            let alarmTypeIdList = [];
            if (alarmTypeNode) {
                alarmTypeNode.forEach(element => {
                    alarmTypeIdList.push(element.id);
                });
            }
            let deviceTreeNodeList = this.$refs.TdDeviceTree.getSelectedNodes();
            let param = {
                iEvent: this.fromAlarmInfo.sAlarmEventId,
                sAlarmLevelId: this.fromAlarmInfo.sAlarmLevelId,
                alarmTypeIdList: alarmTypeIdList,
                startTime: this.fromAlarmInfo.startTime,
                endTime: this.fromAlarmInfo.endTime,
                alarmTypeShow: this.alarmTypeShow,
                iDataType: 0,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                isPage: true,
                orgDeviceTreeVoList: deviceTreeNodeList
            };
            return param;
        },
        // 组件关闭需要调用的方法
        submit() {
            if (!this.isSelectDevice()) {
                this.$message({ type: 'info', showClose: true, message: this.$t('pgMessage.PLEASE_SELECT_QUERY_DEVICE_CONDITION') });
                return;
            }
            this.btnQuery();
        },
        //获取当前日期
        getNowDate() {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            if (month < 10) {
                month = '0' + month;
            }
            if (day < 10) {
                day = '0' + day;
            }
            return year + '-' + month + '-' + day;
        },
        decodeUTF8(arr) {
            var str = '';
            for (var i = 0; i < arr.length; i++) {
                str += String.fromCharCode(arr[i]);
            }
            return decodeURIComponent(escape(str));
        },
        showVideo(row) {
            this.hasLoading = true;
            let videoFile = row.sVideoFile;
            //录像文件参数
            let videoFileObj = JSON.parse(videoFile);
            //根据通道查询中间件、主机信息
            api.queryDeviceInfoForVideoPlayByDeviceId({ id: videoFileObj.channelId }, response => {
                if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.hasLoading = false;
                    this.$log.error('/device/external/queryDeviceInfoForVideoPlayByDeviceId', response.data.statusMessage);
                    return;
                }
                let result = response.data.content;
                if (result && result.msDeviceId && result.hostDeviceId) {
                    //查询存储服务器设备id
                    api.queryDeviceById([videoFileObj.nvrId], response => {
                        if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.hasLoading = false;
                            this.$log.error('/device/queryDeviceById', response.data.statusMessage);
                            return;
                        }
                        let nvrResult = response.data.content;
                        if (nvrResult && nvrResult.length > 0) {
                            this.initPlayVideoParam(videoFileObj, result, nvrResult);
                        } else {
                            this.hasLoading = false;
                            this.$message({ type: 'info', showClose: true, message: this.$t('pgMessage.NOT_QUERY_LINKAGE_VIDEO_NVR_INFO') });
                        }
                    });
                } else {
                    this.hasLoading = false;
                    this.$message({ type: 'info', showClose: true, message: this.$t('pgMessage.NOT_QUERY_LINKAGE_VIDEO_CHANNEL_INFO') });
                }
            });
        },
        initPlayVideoParam(videoFileObj, result, nvrResult) {
            let file = {};
            let fileName = videoFileObj.fileName;
            if (fileName && fileName.length > 4 && fileName.substring(fileName.length - 4) == '.mp4') {
                file = this.getFilePathPlayVideoParam(result, nvrResult, videoFileObj);
            } else {
                file = this.getTimePlayVideoParam(result, nvrResult, videoFileObj);
            }
            this.playVideo(file);
        },
        //按照文件路径进行播放
        getFilePathPlayVideoParam(result, nvrResult, videoFileObj) {
            let file = {};
            let fileInfo = {};
            file.canDownLoad = true;
            file.canPlayback = true;
            file.caption = result.chCaption;
            file.client_sup_id = result.msDeviceId;
            file.client_sup_ip = result.msDeviceIp;
            file.client_sup_port = result.msDevicePort;
            file.dev_id = nvrResult[0].sDeviceId;
            file.dev_sup_id = nvrResult[0].sDeviceId;
            file.filename = videoFileObj.fileName;
            file.hostcaption = result.hostCaption;
            file.password = result.passwrod;
            file.play_type = 1;
            file.username = result.username;
            file.sId = videoFileObj.channelId;
            file.dev_type = result.hostType;

            fileInfo.ch = result.chNum;
            fileInfo.devid = nvrResult[0].sDeviceId;
            fileInfo.driveno = '';
            fileInfo.filename = videoFileObj.fileName;
            fileInfo.filetype = 1;
            fileInfo.size = -1;
            fileInfo.pbtData = '';
            fileInfo.startcluster = '';
            let alarmTime = new Date(videoFileObj.startTime.replace(/-/g, '/'));
            var record_time = videoFileObj.recordTime;
            var endtime = new Date(alarmTime.getTime() + record_time * 1000);
            fileInfo.starttime = videoFileObj.startTime;
            fileInfo.endtime = this.formatDate(endtime);
            file.file_info = fileInfo;
            return file;
        },
        //按照时间段进行播放
        getTimePlayVideoParam(result, nvrResult, videoFileObj) {
            let file = {};
            let fileInfo = {};
            file.client_sup_id = result.msDeviceId;
            file.client_sup_ip = result.msDeviceIp;
            file.client_sup_port = result.msDevicePort;
            file.username = '';
            file.password = '';
            file.play_type = 1;
            file.filename = '';
            file.dev_id = nvrResult[0].sDeviceId;
            file.dev_sup_id = nvrResult[0].sDeviceId;
            file.caption = result.chCaption;
            file.hostcaption = result.hostCaption;
            file.canPlayback = true;
            file.canDownLoad = true;
            file.host_id = result.hostDeviceId;
            file.sId = videoFileObj.channelId;
            file.dev_type = result.hostType;

            fileInfo.ch = result.chNum;
            fileInfo.filename = '';
            fileInfo.size = 0;
            let alarmTime = new Date(videoFileObj.startTime.replace(/-/g, '/'));
            var record_time = videoFileObj.recordTime;
            var endtime = new Date(alarmTime.getTime() + record_time * 1000);
            fileInfo.starttime = videoFileObj.startTime;
            fileInfo.endtime = this.formatDate(endtime);
            fileInfo.driveno = 0;
            fileInfo.startcluster = 0;
            fileInfo.filetype = 3;
            fileInfo.pbtData = '';
            fileInfo.userLevel = 0;
            fileInfo.devid = result.hostDeviceId;
            file.file_info = fileInfo;
            return file;
        },
        //回放联动录像文件
        playVideo(file) {
            //查询回放视频需要的参数
            let socketId = JSON.parse(sessionStorage.getItem('socketInfo')).agentId;
            let data = {
                agentId: socketId,
                platform:
                    window.location.protocol +
                    '//' +
                    window.location.hostname +
                    (window.location.port ? ':' + window.location.port : '') +
                    '/' +
                    JSON.parse(sessionStorage.getItem('socketInfo')).platform,
                token: sessionStorage.getItem('token'),
                sender: 'platformClient', //平台名称，固定写platformClient
                cmd: 101,
                clientlist: [
                    'PlayBackClient' //固定写VideoMonitorClient
                ],
                param: {
                    platIp: window.location.hostname, //平台ip
                    platPort: window.location.port, //平台端口
                    id: '',
                    rtsp: '',
                    username: sessionStorage.username,
                    exeTitle: '平台回放器',
                    lang: 'CN',
                    skin: window.vue.$store.state.skin,
                    layout: 'layoutGisPlayback',
                    isAlarm: 1,
                    webServiceUrlForQt: '/pangu/exeInteraction/queryResourceConfig',
                    control: [
                        {
                            name: 'LocalPlaybackPlayer',
                            param: file
                        }
                    ]
                }
            };
            window.vue.$socketApi.send(socketId, data, this.callback);
        },
        callback(item) {
            this.hasLoading = false;
            if (!item || item.cmd != 10101) {
                this.$log.error('playVideo callback', item);
            }
        },
        formatDate(date, fmt) {
            if (typeof date == 'string') {
                return date;
            }

            if (!fmt) fmt = 'yyyy-MM-dd hh:mm:ss';

            if (!date || date == null) return null;
            var o = {
                'M+': date.getMonth() + 1, // 月份
                'd+': date.getDate(), // 日
                'h+': date.getHours(), // 小时
                'm+': date.getMinutes(), // 分
                's+': date.getSeconds(), // 秒
                'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
                S: date.getMilliseconds() // 毫秒
            };
            if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
            for (var k in o) {
                if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
            }
            return fmt;
        },
        dlalogExportPictureClose() {
            this.exportPictureVailable = false;
        },
        showVideoFront(row) {
            this.hasLoading = true;
            //根据通道查询中间件、主机信息
            api.queryDeviceInfoForVideoPlayByDeviceId({ id: row.sDeviceId }, response => {
                if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.hasLoading = false;
                    this.$log.error('/device/external/queryDeviceInfoForVideoPlayByDeviceId', response.data.statusMessage);
                    return;
                }
                let result = response.data.content;
                if (result && result.msDeviceId && result.hostDeviceId) {
                    let viewTime = 15;
                    // 获取列表信息
                    api.getDictValuesByTag({ sTag: 'PANGU_FRONT_VIDEO_TIME' }, response => {
                        if (response.data.content) {
                            viewTime = response.data.content[0].sCode;
                        }
                    });

                    let param = {};
                    param.cameraSId = row.sDeviceId;
                    let alarmTime = new Date(row.dtTime.replace(/-/g, '/'));
                    var starttime = new Date(alarmTime.getTime() - viewTime * 1000);
                    var endtime = new Date(alarmTime.getTime() + viewTime * 1000);
                    param.startTime = this.formatDate(starttime);
                    param.endTime = this.formatDate(endtime);
                    let storageType = [1, 2];
                    param.recStorageTypeOrderList = storageType;
                    param.fileType = 3;
                    api.queryVideoInfo(JSON.stringify(param), response => {
                        if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('recCenterStorage/listRecFindFile', response.data.statusMessage);
                            this.hasLoading = false;
                            return;
                        }
                        let result = response.data.content;
                        if (result && result.detailVo && result.recData && result.recData.length > 0 && result.recData[0].recFile && result.recData[0].recFile.length > 0) {
                            let fileVideo = result.recData[0].recFile[0];
                            let file = this.getTimePlayVideoParamNew(result.detailVo, result.recData[0], row, result.storageType, 15, starttime, endtime);
                            this.playVideo(file);
                        } else {
                            this.hasLoading = false;
                            this.$message({ type: 'warning', showClose: true, message: this.$t('pgError.ERROR_NO_VIDEO_WAS_FOUND') });
                        }
                    });
                } else {
                    this.hasLoading = false;
                    this.$message({ type: 'info', showClose: true, message: this.$t('pgMessage.NOT_QUERY_LINKAGE_VIDEO_CHANNEL_INFO') });
                }
            });
        },
        //按照时间段进行播放
        getTimePlayVideoParamNew(result, nvrResult, item, storageType, backTime, starttime1, endTime1) {
            let recFile = nvrResult.recFile[0];
            let middlewareInfo = result.middlewareInfo;
            let videoHostInfo = result.videoHostInfo;
            let channelInfo = result.channelInfo;
            //0集中存储 1前端nvr 2前端nvr相机
            let dev_id = '';
            let dev_sup_id = '';
            let play_type = 1;
            if (storageType == 0) {
                dev_id = nvrResult.recConfigInfoVo.storageServerId;
                dev_sup_id = nvrResult.recConfigInfoVo.storageServerId;
            } else if (storageType == 1 || storageType == 2) {
                play_type = 2;
                dev_id = videoHostInfo.sDeviceId;
                dev_sup_id = middlewareInfo.sDeviceId;
            }

            let file = {};
            let fileInfo = {};
            file.client_sup_ip = middlewareInfo.sIp;
            file.client_sup_id = middlewareInfo.sDeviceId;
            file.client_sup_port = middlewareInfo.iPort;
            file.username = '';
            file.password = '';
            file.play_type = play_type;
            file.filename = '';
            file.dev_id = dev_id;
            file.dev_sup_id = dev_sup_id;
            file.caption = channelInfo.sName;
            file.hostcaption = videoHostInfo.sName;
            file.canPlayback = true;
            file.canDownLoad = true;
            file.host_id = videoHostInfo.sDeviceId;
            file.dev_type = parseInt(videoHostInfo.type);
            fileInfo.ch = channelInfo.num;
            fileInfo.filename = '';
            fileInfo.size = 0;
            // let alarmTime = new Date(item.dtTime.replace(/-/g, '/'));
            // var starttime = new Date(alarmTime.getTime() - backTime * 1000);
            // var endtime = new Date(alarmTime.getTime() + backTime * 1000);
            fileInfo.starttime = this.formatDate(recFile.start_time);
            fileInfo.endtime = this.formatDate(recFile.end_time);
            fileInfo.driveno = 0;
            fileInfo.startcluster = 0;
            fileInfo.filetype = recFile.file_type;
            fileInfo.pbtData = '';
            fileInfo.userLevel = 0;
            fileInfo.devid = videoHostInfo.sDeviceId;
            file.file_info = fileInfo;
            return file;
        }
    },
    watch: {
        ['fromAlarmInfo.startTime'](val) {
            let dateVal = this.fromAlarmInfo.endTime;
            if (dateVal && val && new Date(val).getTime() > new Date(dateVal).getTime()) {
                this.fromAlarmInfo.endTime = val;
            }
        },
        ['fromAlarmInfo.endTime'](val) {
            let dateVal = this.fromAlarmInfo.startTime;
            if (dateVal && val && new Date(dateVal).getTime() > new Date(val).getTime()) {
                this.fromAlarmInfo.startTime = val;
            }
        }
    }
};
</script>
<style scoped>
.el-icon-circle-close {
    color: white;
}
.el-image-viewer__img {
    max-width: 1000px !important;
    max-height: 700px !important;
}
.imageCardClass {
    width: 19%;
    margin-left: 5px;
    margin-top: 5px;
    border: 1px solid #c0c4cc;
}
</style>
